import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'booleanValue'
})
export class BooleanValuePipe implements PipeTransform {
    public transform(value: boolean): string {
        return value ? 'Yes' : 'No';
    }
}
